(function (app, ng) {
    app.controller("covidMarketUpdatesCtrl", covidMarketUpdatesCtrl);
    covidMarketUpdatesCtrl.$inject = ["$mdDialog", "data"];

    function covidMarketUpdatesCtrl($mdDialog, data) {
        var $ctrl = this;

        $ctrl.closeDialog = function ($event) {
            return $mdDialog.hide($event);
        };

        $ctrl.$onInit = function () {
            $ctrl.data = data;
        };
    }
})(window.app, window.angular); // jshint ignore:line